<template>
    <app-page>
        <div class="flex flex-wrap justify-center items-center h-full w-full min-h-full bg-blue p-8">
            <div class="max-w-full w-full md:w-1/3">
                <div class="bg-white shadow rounded-lg p-8 md:max-w-sm max-w-full md:mx-auto mx-6">
                    <header class="block mb-8">
                        <a href="/" class="block">
                            <app-logo class="block" />
                        </a>
                    </header>

                    <slot />
                </div>
            </div>
        </div>
    </app-page>
</template>

<script>
    import Page from '@/components/Page';
    import Logo from '@/components/Logo';
    export default {
        name: 'layout-auth',
        
        components: {
            'app-page': Page,
            'app-logo': Logo
        }
    }
</script>

<style lang="scss">
    
</style>


// WEBPACK FOOTER //
// src/layouts/Auth.vue